import React, { useCallback, useEffect, useRef, useState } from "react";
import { ReactComponent as Chat } from "../../Global Icons/chat&support.svg";
import { useDispatch, useSelector } from "react-redux";
import { getChatListAdmin } from "../../Redux/Actions/chatAction";
import "./chatListAdmin.css";

const ChatListAdmin = ({
  setSelectedBookingId,
  chatWith,
  setChatWith,
  setSelectedPerson,
}) => {
  const [messages, setMessages] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [chatList, setChatList] = useState([]);
  const [allChats, setAllChats] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 18,
    total: 0,
  });

  const dispatch = useDispatch();
  const listRef = useRef(null);

  const fetchDetails = useCallback(
    async (page, limit) => {
      if (!chatWith) return;
      setLoading(true);
      await dispatch(getChatListAdmin({ page, limit, chat_with: chatWith }));
      setLoading(false);
    },
    [dispatch, chatWith]
  );

  useEffect(() => {
    const listEl = listRef.current;
    if (!listEl) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = listEl;

      if (
        scrollHeight - scrollTop - clientHeight < 100 &&
        !loading &&
        pagination.current * pagination.pageSize < pagination.total
      ) {
        setPagination((prev) => {
          const nextPage = prev.current + 1;
          fetchDetails(nextPage, prev.pageSize);
          return { ...prev, current: nextPage };
        });
      }
    };

    listEl.addEventListener("scroll", handleScroll);

    return () => {
      listEl.removeEventListener("scroll", handleScroll);
    };
  }, [loading, pagination.total, fetchDetails]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
    setChatList([]);
    setAllChats([]);
    fetchDetails(1, pagination.pageSize);
  }, [chatWith, fetchDetails]);

  const { chats } = useSelector((state) => state.chats || {});

  useEffect(() => {
    if (chats?.total) {
      setPagination((prev) => ({ ...prev, total: chats.total }));
    }
    if (Array.isArray(chats?.data)) {
      setChatList((prevList) =>
        pagination.current === 1 ? chats.data : [...prevList, ...chats.data]
      );
      setAllChats((prevAll) =>
        pagination.current === 1 ? chats.data : [...prevAll, ...chats.data]
      );
    }
  }, [chats, pagination.current]);

  const chatGroups = ["users", "builders"];

  const handleChatClick = (chat) => {
    let selectedDetails = {
      name: "",
      email: "",
      contactNumber: "",
      countryCode: "",
    };

    if (chatWith === "users") {
      selectedDetails.name = chat?.user?.name || "";
      selectedDetails.email = chat?.user?.email || "";
      selectedDetails.contactNumber = chat?.user?.contact_number || "";
      selectedDetails.countryCode = chat?.user?.country_code || "";
    } else {
      selectedDetails.name = chat?.builder?.brand_name || "";
      selectedDetails.email = chat?.builder?.primary_email || "";
      selectedDetails.contactNumber = chat?.builder?.primary_contact_number || "";
      selectedDetails.countryCode = chat?.builder?.primary_country_code || "";
    }

    setSelectedBookingId(
      chatWith === "users" ? chat?.user?._id : chat?.builder?._id
    );
    setSelectedPerson(selectedDetails);
    setSelectedBooking(
      chatWith === "users" ? chat?.user?._id : chat?.builder?._id
    );
    setMessages([]);
  };

  const handleSearChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
  };

  // Sort chats to show new messages on top by last_message_time (descending)
  const sortedChatList = [...allChats].sort((a, b) => {
    const aTime = a.last_message_time || 0;
    const bTime = b.last_message_time || 0;
    return bTime - aTime;
  });

  // Filter chats based on search input
  const filteredChatList = sortedChatList.filter((chat) => {
    const name =
      chatWith === "users"
        ? chat?.user?.name?.toLowerCase()
        : chat?.builder?.brand_name?.toLowerCase();
    return name?.includes(searchValue.toLowerCase());
  });

  return (
    <div>
      <div>
        <div
          className="chat_left_panel"
          ref={listRef}
          style={{ overflowY: "auto", maxHeight: "600px" }}
        >
          <div className="chat_left_panel_icon">
            <Chat style={{ height: "34px", width: "34px" }} />
            <h3>Chats</h3>
          </div>
          <div className="chat_group_selection">
            {chatGroups.map((group) => (
              <div
                key={group}
                onClick={() => setChatWith(group)}
                className={`chat_group_item ${
                  chatWith === group ? "selected" : ""
                }`}
              >
                <h2>
                  {group.charAt(0).toUpperCase()}
                  {group.slice(1)}
                </h2>
              </div>
            ))}
          </div>
          <div className="search-container">
            <div className="search-input-wrapper">
              <input
                type="text"
                value={searchValue}
                onChange={handleSearChange}
                className="search-input"
                placeholder="Search..."
              />
            </div>
          </div>
          <div className="chat-left">
            {filteredChatList.length === 0 ? (
              <div>No chats to display</div>
            ) : (
              filteredChatList.map((chat, index) => {
                const unreadCount = chat.unread_count || 0;

                return (
                  <div
                    className="individual_chat"
                    key={index}
                    onClick={() => handleChatClick(chat)}
                    style={{ position: "relative" }}
                  >
                    <img
                      src={
                        chat?.profile_image
                          ? chat.profile_image
                          : require("../../Global Icons/AlternateImage.png")
                      }
                      alt="profile_image"
                    />
                    <div className="chatUsers-list">
                      {chatWith === "users" ? (
                        chat?.user?.name && typeof chat.user.name === "string" ? (
                          <span className="userName">
                            {chat.user.name.slice(0, 20)}...
                          </span>
                        ) : (
                          ""
                        )
                      ) : chat?.builder?.brand_name &&
                        typeof chat.builder.brand_name === "string" ? (
                        <span>{chat.builder.brand_name}</span>
                      ) : (
                        ""
                      )}
                      <span className="last-message">
                        {chat.last_message && typeof chat.last_message === "string"
                          ? `${chat.last_message.slice(0, 8)}...`
                          : ""}
                      </span>
                    </div>
                    {unreadCount > 0 && (
                      <div className="message-count-badge">{unreadCount}</div>
                    )}
                  </div>
                );
              })
            )}
          </div>
          {loading && <div className="loading-indicator">Loading...</div>}
        </div>
      </div>
    </div>
  );
};

export default ChatListAdmin;
